import StickyCart from './StickyCart';
export default StickyCart;
